module.exports = __webpack_public_path__ + "static/media/ad.4fc7c4c1.svg";